import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/banner_work.jpeg'


const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "achieve-jupas-wrapper"
}

import { computed, onMounted, reactive, ref, watch } from 'vue';

// icons
import { personCircle, compass, arrowForward, navigate, settingsOutline, checkmark, arrowBack,
        add, close, checkmarkCircle, alertCircle, pencil, peopleOutline, qrCodeOutline,
        createOutline, calendarOutline, calendarClearOutline, play, } from 'ionicons/icons';

// components
import { IonPage, IonToolbar, IonContent, IonModal, IonHeader, IonTitle,
        IonCard, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonSegment, IonSegmentButton,
        IonGrid, IonCol, IonRow, IonSpinner, IonNote, IonButtons, IonButton, IonIcon,
        IonBadge, IonChip, IonList, IonItem, IonLabel, IonAccordion, IonAccordionGroup,
        loadingController, modalController, toastController, } from '@ionic/vue';
import ActionAccordionGroup from '@/components/shared/ActionAccordionGroup.vue';
import ParentConsentSignatureModal from '@/components/modals/ParentConsentSignatureModal.vue';

// Secondary School
import AchieveJUPASResultPageModal from '@/components/achievejupas/AchieveJUPASResultPageModal.vue';
import AB4ProfessionResultPageModal from '@/components/secondary/AB4ProfessionResultPageModal.vue';
import AB4DisciplineResultPageModal from '@/components/secondary/AB4DisciplineResultPageModal.vue';
import WorkEventsModal from '@/components/secondary/events/WorkEventsModal.vue';
import SLPModal from '@/components/secondary/ABSLPModal.vue';
import ABProfessionSelectModal from '@/components/pss/profession/ABProfessionSelectModal.vue';

// types
import { Session, Discipline, Profession, Program, Step1Option, User, Service, } from '@/types';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { utils } from '@/composables/utils';

// services
import ABSService from '@/services/ABSService';

// methods

export default /*@__PURE__*/_defineComponent({
  __name: 'SecStudentActionCardList',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const { openImageModal, openModal, getF3YearDSE, getF4YearDSE, getF5YearDSE, getF6YearDSE, promptRollCallCode,
        getProxyImgLink, getQRCodeUrl, copyText, openServiceModal, } = utils();

// state variables
const loadingData = computed(() => store.state.loadingUser || store.state.loadingData);
const loadingPortalData = computed(() => store.state.loadingUser || store.state.loadingData || store.state.loadingPortalData);
const settings = computed(() => store.state.settings);
const user = computed(() => store.state.user);
const userRelatedSchool = computed(() => store.getters.userRelatedSchool);

// View switcher
const selectedViews = reactive({
  form: "F5-6",
  type: "AchieveJUPAS",
}); // mainly for switching between AchieveJUPAS & Resources

// Work Services / Sessions
const workServices = computed<Service[]>(() => store.getters.getServicesByTypes(["Work"]));
const workVisitEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('work-campus-visit'));
const workWorkshopEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('work-workshop-2'));

const getServices = (targetNature: any = null) => {
  const yearDSE = Number(user.value.yearDSE);
  const targetForms = (yearDSE == getF6YearDSE() ? ['F.6', 'F.5'] : (yearDSE == getF4YearDSE() ? ['F.4'] : ['F.5']));
  const targetServices = (workServices.value || []).filter(s => {
    if (targetNature && s.nature != targetNature) return false; // Workshop / Visit
    if (store.getters.getLastAppliedSessionByServiceId(s.id)) return true; // contain applied session
    if (s.status == 'Inactive' || !s.nature) return false;
    
    // only include services related to the form
    if (targetForms && s.targetForms && s.targetForms.length > 0 && !s.targetForms.some(f => targetForms.includes(f))) return false;
    
    // skip because nominated by teachers (TBC: align layout with teachers?)
    if (['Talk at your school', 'Video'].includes(s.nature)) return false;

    return s.targetSchoolBands.length == 0 || userRelatedSchool.value.id == 'beacon1' ||
            s.targetSchoolBands.includes(userRelatedSchool.value.band);
  }).map(s => {
    s.lastAppliedSession = store.getters.getLastAppliedSessionByServiceId(s.id); // SLP visit / workshop
    return s;
  });
  return targetServices;
};
const getWorkshopServicesByUserLevel = (userLevel) => {
  const services = getServices('Workshop');
  const isShortlisted = (lastAppliedSession) => {
    if (!lastAppliedSession) return false;
    const { interviewStatus, response } = lastAppliedSession.userResponse;
    return interviewStatus?.includes('Accepted') || ['Attended', 'Confirmed'].includes(response);
  }
  switch (userLevel) {
    case 'eligible-work-applicant': 
      return services.filter(s => s.status != 'Inactive' && !isShortlisted(s.lastAppliedSession));
    case 'shortlisted-work-applicant':
      return services.filter(s => isShortlisted(s.lastAppliedSession));
  }
  return services;
}

/**
 * AB3 / AB4
 */
const userABSIntakeSessions = computed<Session[]>(() => store.getters.userABSIntakeSessions);
const isAB4User = computed(() => store.getters.isAB4User);
const userChoices = reactive({
  chosenDisciplines: [] as Discipline[],
  step1ProfessionReason: "",
  step1ProfessionAction: "",
  step2DisciplineReason: "",
  step2DisciplineAction: "",
  chosenProfessions: [] as Profession[],
  chosenOptions: [] as Step1Option[],
});
const getUserChoiceUpdatingObj = () => {
  const { chosenOptions, chosenProfessions, step1ProfessionReason, step1ProfessionAction, step2DisciplineReason, step2DisciplineAction, chosenDisciplines, } = userChoices;
  return {
    step1OptionIds: chosenOptions.map(o => o.id).join(" , "),
    step1OrderedProfessionIds: chosenProfessions.map(p => p.id).join(" , "),
    step1ProfessionReason: step1ProfessionReason,
    step1ProfessionAction: step1ProfessionAction,
    step2DisciplineIds: chosenDisciplines.map(d => d.id).join(" , "),
    step2DisciplineReason: step2DisciplineReason,
    step2DisciplineAction: step2DisciplineAction,
  };
}
const someAnswersUpdated = () => {
  const updatingObj = getUserChoiceUpdatingObj();
  return Object.keys(updatingObj).some(field => (user.value[field] != updatingObj[field]));
};
const saveUserChoices = async (noLoading = false) => {
  if (someAnswersUpdated()) {
    const loading = await loadingController.create({});
    if (!noLoading) await loading.present();

    // Update DB
    const updatingObj = getUserChoiceUpdatingObj();
    ABSService.saveUserChoices(updatingObj);

    // Update Store
    const { chosenOptions, chosenProfessions, step1ProfessionReason, step1ProfessionAction, step2DisciplineReason, step2DisciplineAction, chosenDisciplines, } = userChoices;
    store.commit('updateUser', {
      ...updatingObj,
      lastSelectedStep1Options: chosenOptions.slice(),
      lastSelectedProfessions: chosenProfessions.slice(),
      step1ProfessionReason: step1ProfessionReason,
      step1ProfessionAction: step1ProfessionAction,
      step2DisciplineReason: step2DisciplineReason,
      step2DisciplineAction: step2DisciplineAction,
      lastSelectedDisciplines: chosenDisciplines.slice(),
    });
    loading.dismiss();
    if (!noLoading) {
      const toast = await toastController.create({
        message: t('successSave'),
        duration: 3000,
        position: 'top',
      });
      toast.present();
    }
  }
};

/**
 * Professions
 */
const openProfessionSelectModal = async () =>  {
  const modal = await modalController.create({
    cssClass: 'tall-modal',
    component: AB4ProfessionResultPageModal,
    componentProps: {
      prefilledProfessions: userChoices.chosenProfessions.slice(),
      oldUserProfessions: user.value.userProfessions?.slice() || [],
    },
    backdropDismiss: false,
  });
  modal.onDidDismiss().then(({ data }) => {
    if (data && data.selectedProfessions) {
      // Chosen professions
      userChoices.step1ProfessionReason = data.selectedProfessions[0]?.reason || "";
      userChoices.step1ProfessionAction = data.selectedProfessions[0]?.action || "";
      userChoices.chosenProfessions = data.selectedProfessions;
      saveUserChoices(data.noLoading);

      // User profession reactions
      ABSService.upsertUserProfessions(data.userProfessions);
      store.commit('updateUser', { userProfessions: data.userProfessions });
    }
  });
  return modal.present();
}

/**
 * Disciplines
 */
const openDisciplineSelectModal = async () =>  {
  const modal = await modalController.create({
    cssClass: 'tall-modal',
    component: AB4DisciplineResultPageModal,
    componentProps: {
      prefilledDisciplines: userChoices.chosenDisciplines.slice(),
      targetProfessions: userChoices.chosenProfessions.slice(0, 5),
      oldUserDisciplines: user.value.userDisciplines?.slice() || [],
    }
  });
  modal.onDidDismiss().then(({ data }) => {
    if (data && data.chosen) {
      // Chosen disciplines
      userChoices.step2DisciplineReason = data.chosen[0]?.reason || "";
      userChoices.step2DisciplineAction = data.chosen[0]?.action || "";
      userChoices.chosenDisciplines = data.chosen;
      saveUserChoices(data.noLoading);

      // User discipline reactions
      ABSService.upsertUserDisciplines(data.userDisciplines);
      store.commit('updateUser', { userDisciplines: data.userDisciplines });
    }
  });
  return modal.present();
}

/**
 * INIT
 */
const loadSavedUserChoices = (user: User) => {
  if (user.id) {
    userChoices.chosenOptions = user.lastSelectedStep1Options || [];
    userChoices.chosenProfessions = user.lastSelectedProfessions || [];
    userChoices.step1ProfessionReason = user.step1ProfessionReason || "";
    userChoices.step1ProfessionAction = user.step1ProfessionAction || "";
    userChoices.chosenDisciplines = user.lastSelectedDisciplines || [];
    userChoices.step2DisciplineReason = user.step2DisciplineReason || "";
  }
}
onMounted(() => {
  loadSavedUserChoices(user.value);
});
watch(loadingPortalData, () => { // triggered only when direct access to this page
  loadSavedUserChoices(user.value);
  });

const isUserAttendedLesson = (lessonId) => (user.value.sessionResponses?.find(r => (r.lessonId == lessonId && r.attended == 'Yes')));

// modals
const openWorkEventsModal = async (anchorEvId, showTeacherActions = false) => await openModal(WorkEventsModal, {
  showTeacherActions, chosenDisciplines: userChoices.chosenDisciplines.slice(0, 5), anchorEvId,
});
const openSLPModal = async (isPreview = false) => {
  const ev = store.getters.getLastAttendedSession;
  return await openModal(SLPModal, { isPreview, ev, serviceId: ev?.serviceId, relatedProgramId: ev?.relatedProgramId, relatedClientId: user.value.clientId }, "", false)
};

// AB3 / AB4 Functions
const filteredAB4Sessions = (targetAnchorEvId) => (userABSIntakeSessions.value.filter(s => s.anchorEventId == targetAnchorEvId));
const isShowEvent = (ev: Session) => {
  const evStart = new Date(ev.startTimeStr);
  return (evStart > new Date(+new Date() - 5*86400000) && evStart < new Date(+new Date() + 30*86400000)) || ev.userResponse?.confirmed == "Yes"
};
const openAB3Modal = async () =>  {
  const modal = await modalController.create({
    cssClass: 'tall-modal',
    component: AchieveJUPASResultPageModal,
    componentProps: { isAB3: true, }
  });
  return modal.present();
};
const isSelectedProfessions = () => (userChoices.chosenProfessions.length > 0);
const isSelectedDisciplines = () => (userChoices.chosenDisciplines.length > 0);

// Other
const getSessionById = (sessionId: any) => (store.getters.getSessionById(sessionId));
const getServiceName = (service) => {
  const { lastAppliedSession, name } = service;
  return lastAppliedSession ? `${name} (${lastAppliedSession.date} ${lastAppliedSession.startTime})` : name;
};
const getServicesByIds = (ids) => (workServices.value || []).filter(s => ids.includes(s.id)); // TMP: for demo

// AI Chatbot (for AI competition - image generation)
const openAIProfessionImageModal = () => {
  //return openModal(ChatbotModal, { isImageBot: true }); // image bot
  return openModal(ABProfessionSelectModal, { isAIImageCompetition: true, }); // image bot
}

// Videos
const openVideoParentConsentModal = (videoId) => {
  return openModal(ParentConsentSignatureModal, { videoId, target: 'video' });
}

return (_ctx: any,_cache: any) => {
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_event_card = _resolveComponent("event-card")!
  const _component_home_action_header = _resolveComponent("home-action-header")!

  return (loadingData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSpinner))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegment), {
              class: "view-type-segment",
              mode: "ios",
              modelValue: selectedViews.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedViews.type) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSegmentButton), {
                  value: "Sharing",
                  class: "short-segment-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(qrCodeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), {
                  value: "resources",
                  class: "short-segment-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      class: "no-text-transform",
                      style: {"font-size":"2em"}
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("😍")
                      ])),
                      _: 1,
                      __: [8]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "AchieveJUPAS" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      class: "no-text-transform",
                      style: {"line-height":"1.5"}
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("b", null, "AchieveJUPAS", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("2.0 (beta)")
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "school-arranged" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      class: "no-text-transform",
                      style: {"line-height":"1.5"}
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("School"),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("arranged")
                      ])),
                      _: 1,
                      __: [10]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), {
                  value: "sndas",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("SNDAS")
                      ])),
                      _: 1,
                      __: [11]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), {
                  value: "overseas-study",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("Overseas Study")
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), {
                  value: "e-app",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("E-App")
                      ])),
                      _: 1,
                      __: [13]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (selectedViews.type == 'Sharing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(IonCard), {
                class: "class-bar",
                style: {"margin-top":"0","margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonAccordionGroup), { value: "Sharing" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonAccordion), {
                            style: {"--min-height":"24px","padding-left":"12px"},
                            value: "Sharing"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                lines: "full",
                                slot: "header"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), { style: {"margin":"4px 8px 4px 12px"} }, {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createElementVNode("p", { style: {"font-weight":"500"} }, [
                                        _createElementVNode("b", null, "Share this tool with my classmates")
                                      ], -1)
                                    ])),
                                    _: 1,
                                    __: [14]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonList), {
                                class: "ion-text-center",
                                slot: "content"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    _createElementVNode("img", {
                                      style: {"width":"300px"},
                                      src: _unref(getQRCodeUrl)(`https://ab.fdmt.hk/s/${user.value.schoolId}`)
                                    }, null, 8, _hoisted_4)
                                  ]),
                                  _createElementVNode("p", null, "ab.fdmt.hk/s/" + _toDisplayString(user.value.schoolId), 1),
                                  _createVNode(_unref(IonButton), {
                                    color: "success",
                                    size: "small",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyText)(`https://ab.fdmt.hk/s/${user.value.schoolId}`)))
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" Copy ")
                                    ])),
                                    _: 1,
                                    __: [15]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (selectedViews.type === 'resources')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[35] || (_cache[35] = _createElementVNode("img", {
                  src: _imports_0,
                  style: {"width":"100%","margin-bottom":"-3px"}
                }, null, -1)),
                _createVNode(_unref(IonToolbar), { style: {"--min-height":"27px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      lines: "full",
                      button: "",
                      detail: "",
                      color: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openSLPModal(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { class: "ion-text-wrap ion-text-center" }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "AchieveSLP preview", -1),
                            _createElementVNode("small", null, "unlocked upon successful Work event enrollment", -1)
                          ])),
                          _: 1,
                          __: [16]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCard), { style: {"margin-top":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
                      default: _withCtx(() => [
                        (user.value.relatedVideos?.length > 0)
                          ? (_openBlock(), _createBlock(ActionAccordionGroup, {
                              key: 0,
                              noPadding: false,
                              value: "parent-consent-videos",
                              headerColor: 'fdmtgrey'
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createElementVNode("b", null, "Video(s)", -1)
                                  ])),
                                  _: 1,
                                  __: [17]
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.relatedVideos, (video) => {
                                  return (_openBlock(), _createBlock(_component_home_action_item, {
                                    key: video.id,
                                    onClick: ($event: any) => (openVideoParentConsentModal(video.id)),
                                    isLesson: true,
                                    title: video.title
                                  }, null, 8, ["onClick", "title"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "eligible-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "1. Eligible Work applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWorkshopServicesByUserLevel('eligible-work-applicant'), (service) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: service.id
                                }, [
                                  _createVNode(_component_home_action_item, {
                                    onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                    isLesson: true,
                                    title: getServiceName(service)
                                  }, null, 8, ["onClick", "title"]),
                                  (service.lastAppliedSession)
                                    ? (_openBlock(), _createBlock(_component_event_card, {
                                        key: 0,
                                        ev: service.lastAppliedSession,
                                        user: user.value,
                                        hideEventDetails: true,
                                        hideApplyButton: true,
                                        style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                      }, null, 8, ["ev", "user"]))
                                    : _createCommentVNode("", true)
                                ])), [
                                  [_vShow, user.value.isAdmin ? !['s87bb705d'].includes(service.id) : true]
                                ])
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value, (ev) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: ev.id
                                }, [
                                  _createVNode(_component_home_action_item, {
                                    onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, ev, true)),
                                    isLesson: true,
                                    title: `${ev.name} (${ev.date} ${ev.startTime})`
                                  }, null, 8, ["onClick", "title"]),
                                  (ev.userResponse)
                                    ? (_openBlock(), _createBlock(_component_event_card, {
                                        key: 0,
                                        ev: ev,
                                        user: user.value,
                                        hideEventDetails: true,
                                        hideApplyButton: true,
                                        style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                      }, null, 8, ["ev", "user"]))
                                    : _createCommentVNode("", true)
                                ])), [
                                  [_vShow, user.value.isAdmin ? !['sd93a34f8'].includes(ev.serviceId) : true]
                                ])
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "shortlisted-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "2. Shortlisted Work applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            (user.value.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['s87bb705d']), (service) => {
                                    return (_openBlock(), _createBlock(_component_home_action_item, {
                                      key: service.id,
                                      onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                      isLesson: true,
                                      title: getServiceName(service)
                                    }, null, 8, ["onClick", "title"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWorkshopServicesByUserLevel('shortlisted-work-applicant'), (service) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: service.id
                              }, [
                                _createVNode(_component_home_action_item, {
                                  onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                  isLesson: true,
                                  title: getServiceName(service)
                                }, null, 8, ["onClick", "title"]),
                                (service.lastAppliedSession)
                                  ? (_openBlock(), _createBlock(_component_event_card, {
                                      key: 0,
                                      ev: service.lastAppliedSession,
                                      user: user.value,
                                      hideEventDetails: true,
                                      hideApplyButton: true,
                                      style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                    }, null, 8, ["ev", "user"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "outstanding-work-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "3. (Outstanding) Work participant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            (user.value.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['sd93a34f8']), (service) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: service.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                        isLesson: true,
                                        title: getServiceName(service)
                                      }, null, 8, ["onClick", "title"]),
                                      (service.lastAppliedSession)
                                        ? (_openBlock(), _createBlock(_component_event_card, {
                                            key: 0,
                                            ev: service.lastAppliedSession,
                                            user: user.value,
                                            hideEventDetails: true,
                                            hideApplyButton: true,
                                            style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                          }, null, 8, ["ev", "user"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value, (ev) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: ev.id
                              }, [
                                _createVNode(_component_home_action_item, {
                                  onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, ev, true)),
                                  isLesson: true,
                                  title: `${ev.name} (${ev.date} ${ev.startTime})`
                                }, null, 8, ["onClick", "title"])
                              ])), [
                                [_vShow, (ev.userResponse && ev.userResponse.isOutstandingStudent)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "work-ambassador",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "4. Work Ambassador")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            (user.value.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByIds(['s1b2ed9be']), (service) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: service.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => (_unref(openServiceModal)(service.id, service.lastAppliedSession, true)),
                                        isLesson: true,
                                        title: getServiceName(service)
                                      }, null, 8, ["onClick", "title"]),
                                      (service.lastAppliedSession)
                                        ? (_openBlock(), _createBlock(_component_event_card, {
                                            key: 0,
                                            ev: service.lastAppliedSession,
                                            user: user.value,
                                            hideEventDetails: true,
                                            hideApplyButton: true,
                                            style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                                          }, null, 8, ["ev", "user"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (user.value.isAdmin || workVisitEvents.value.some(ev => ev.userResponse && ev.userResponse.isOutstandingStudent))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value.filter(ev => ev.userResponse && ev.userResponse.isOutstandingStudent), (ev) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: ev.id
                                    }, [
                                      _createVNode(_component_home_action_item, {
                                        onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, null, true, { isOutstandingParticipantView: true })),
                                        isLesson: true,
                                        title: "Example Work video & previous shooting photos"
                                      }, null, 8, ["onClick"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "bluebird-seed-eligible-applicant",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "5. Bluebird Seed Eligible applicant")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _createVNode(_component_home_action_item, {
                              isLesson: true,
                              title: "Bluebird Seed",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openServiceModal)('bluebird-seed')))
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "bluebird-seed-member",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "6. Bluebird Seed Member")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            (user.value.isAdmin && user.value.schoolId == 'htc')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(_unref(IonItem), { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonLabel), { style: {"padding-left":"32px"} }, {
                                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                                          _createElementVNode("b", null, "Co-supervisors: Ms. Lilian Ho (HTC), Brandon Chan (FDMT)", -1)
                                        ])),
                                        _: 1,
                                        __: [24]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(ActionAccordionGroup, {
                                    style: {"padding-left":"20px"},
                                    noPadding: true,
                                    headerColor: 'light',
                                    value: "tasks"
                                  }, {
                                    header: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createElementVNode("p", null, [
                                        _createElementVNode("b", null, "Project logs")
                                      ], -1)
                                    ])),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_unref(IonItem), {
                                          button: "",
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonLabel), {
                                              class: "ion-text-wrap",
                                              style: {"padding-left":"32px"}
                                            }, {
                                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                _createElementVNode("b", null, "AchieveJUPAS UI Updates", -1),
                                                _createElementVNode("p", null, "Show version history of program choices", -1),
                                                _createElementVNode("p", null, "Expected completion: 2025-04-30", -1)
                                              ])),
                                              _: 1,
                                              __: [26]
                                            }),
                                            _createVNode(_unref(IonBadge), {
                                              color: "medium",
                                              slot: "end"
                                            }, {
                                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                _createTextVNode("Planned")
                                              ])),
                                              _: 1,
                                              __: [27]
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "bluebird-seed-scholarship-holder",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "7. Bluebird Seed Scholarship holder")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[29] || (_cache[29] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1,
                          __: [29]
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "bluebird-member",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "8. Bluebird Member")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[31] || (_cache[31] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1,
                          __: [31]
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "bluebird-scholarship-holder",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "9. Bluebird Scholarship holder")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _cache[33] || (_cache[33] = _createElementVNode("div", null, null, -1))
                          ]),
                          _: 1,
                          __: [33]
                        }),
                        _createVNode(ActionAccordionGroup, {
                          noPadding: false,
                          value: "Other",
                          headerColor: 'light'
                        }, {
                          header: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                              _createElementVNode("b", null, "Other")
                            ], -1)
                          ])),
                          default: _withCtx(() => [
                            _createVNode(_component_home_action_item, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(openServiceModal)('lms-scholarship', getSessionById('e4c145b9'), true))),
                              isLesson: true,
                              title: "HK$300k scholarship",
                              isDisabled: !user.value.isAdmin && Number(user.value.yearDSE) >= _unref(getF5YearDSE)()
                            }, null, 8, ["isDisabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (selectedViews.type == 'school-arranged')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_home_action_header, { title: "University Visits" }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value, (ev) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: ev.id
                      }, [
                        _withDirectives(_createVNode(_component_home_action_item, {
                          onClick: ($event: any) => (_unref(openServiceModal)(ev.serviceId, ev, true)),
                          isLesson: true,
                          title: `${ev.name} (${ev.date} ${ev.startTime})`
                        }, null, 8, ["onClick", "title"]), [
                          [_vShow, user.value.isAdmin || ev.userResponse || ev.clientSchoolId == user.value.schoolId]
                        ]),
                        (ev.userResponse)
                          ? (_openBlock(), _createBlock(_component_event_card, {
                              key: 0,
                              ev: ev,
                              user: user.value,
                              hideEventDetails: true,
                              hideApplyButton: true,
                              style: {"margin":"0","padding-left":"32px","box-shadow":"none"}
                            }, null, 8, ["ev", "user"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  ((user.value.teacher || isAB4User.value) && user.value.yearDSE <= _unref(getF4YearDSE)())
                    ? (_openBlock(), _createBlock(_unref(IonCard), {
                        key: 0,
                        style: {"margin-top":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_header, { title: "AB4" }),
                          _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonAccordionGroup), { value: "L1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonAccordion), {
                                    style: {"--min-height":"24px"},
                                    value: "L1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonIcon), {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_unref(IonLabel), null, {
                                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Lesson 1")
                                              ], -1)
                                            ])),
                                            _: 1,
                                            __: [36]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonList), {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAB4Sessions('abs-session1'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: user.value,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_home_action_item, {
                                title: "Target 1 among 400+ professions",
                                isDone: isSelectedProfessions() && userChoices.step1ProfessionReason && userChoices.step1ProfessionAction,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (openProfessionSelectModal())),
                                isLoading: loadingPortalData.value
                              }, null, 8, ["isDone", "isLoading"]),
                              _createVNode(_unref(IonAccordionGroup), { value: "ab4-l2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonAccordion), {
                                    style: {"--min-height":"24px"},
                                    value: "ab4-l2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonIcon), {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_unref(IonLabel), null, {
                                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Lesson 2")
                                              ], -1)
                                            ])),
                                            _: 1,
                                            __: [37]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonList), {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAB4Sessions('abs-session2'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: user.value,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (user.value.isAdmin || isUserAttendedLesson('abs-session2'))
                                ? (_openBlock(), _createBlock(_component_home_action_item, {
                                    key: 0,
                                    title: "Choose 1-4 among 140+ disciplines",
                                    isDone: isSelectedDisciplines(),
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (openDisciplineSelectModal()))
                                  }, null, 8, ["isDone"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (user.value.isAdmin || ((user.value.teacher || isAB4User.value) && user.value.yearDSE <= _unref(getF4YearDSE)()))
                    ? (_openBlock(), _createBlock(_unref(IonCard), {
                        key: 1,
                        style: {"margin-top":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_home_action_header, { title: "AB3" }),
                          _createVNode(_unref(IonCardContent), { style: {"padding":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonAccordionGroup), { value: "ab3-session1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonAccordion), {
                                    style: {"--min-height":"24px"},
                                    value: "L1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        class: "ion-no-padding",
                                        lines: "full",
                                        slot: "header"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonIcon), {
                                            slot: "start",
                                            icon: null
                                          }),
                                          _createVNode(_unref(IonLabel), null, {
                                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("b", null, "Parent talk")
                                              ], -1)
                                            ])),
                                            _: 1,
                                            __: [38]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonList), {
                                        class: "ion-no-padding",
                                        slot: "content"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAB4Sessions('ab3-session1'), (ev) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_event_card, {
                                              key: ev.id,
                                              ev: ev,
                                              user: user.value,
                                              showStudentFormsOnly: true,
                                              useAccordionView: true
                                            }, null, 8, ["ev", "user"])), [
                                              [_vShow, ev.formattedDateTime && isShowEvent(ev)]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_home_action_item, {
                                title: "AchieveElective (beta)",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (openAB3Modal())),
                                isLoading: loadingPortalData.value
                              }, null, 8, ["isLoading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(AchieveJUPASResultPageModal, { hideTitle: true })
                ]))
      ]))
}
}

})